import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

const base = (size: number) => ({
  width: size, height: size, viewBox: `0 0 ${size} ${size}`, fill: "none",
});

export function LogoIcon({ size = 26, ...rest }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" {...rest}>
      <rect width="26" height="26" rx="6" style={{ fill: "var(--ai-bg)", stroke: "var(--ai-rule)" }} strokeWidth="1" />
      <path d="M10 6 H6 a2 2 0 0 0 -2 2 V18 a2 2 0 0 0 2 2 H10"
        strokeWidth="2.2" strokeLinecap="round" style={{ stroke: "var(--color-text)" }} />
      <path d="M16 6 H20 a2 2 0 0 1 2 2 V18 a2 2 0 0 1 -2 2 H16"
        strokeWidth="2.2" strokeLinecap="round" style={{ stroke: "var(--accent)" }} />
      <circle cx="13" cy="13" r="1.5" style={{ fill: "var(--ai-accent)" }} />
    </svg>
  );
}

export function AISparkleIcon({ size = 16, ...rest }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...rest}>
      <path
        d="M8 1 L10.2 5.8 L15 8 L10.2 10.2 L8 15 L5.8 10.2 L1 8 L5.8 5.8 Z"
        style={{ fill: "var(--ai-accent)" }}
      />
    </svg>
  );
}

export function PlusIcon({ size = 14, ...rest }: IconProps) {
  return (
    <svg {...base(size)} {...rest}>
      <path d={`M${size/2} ${size*0.15}v${size*0.7}M${size*0.15} ${size/2}h${size*0.7}`} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function MenuIcon({ size = 20, ...rest }: IconProps) {
  return (
    <svg {...base(size)} {...rest}>
      <path d={`M3 6h${size-6}M3 ${size/2}h${size-6}M3 ${size-6}h${size-6}`} stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function CloseIcon({ size = 20, ...rest }: IconProps) {
  return (
    <svg {...base(size)} {...rest}>
      <path d={`M${size*0.2} ${size*0.2}l${size*0.6} ${size*0.6}M${size*0.8} ${size*0.2}l-${size*0.6} ${size*0.6}`} stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function SendIcon({ size = 16, ...rest }: IconProps) {
  return (
    <svg {...base(size)} {...rest}>
      <path d={`M${size/2} ${size*0.81}V${size*0.19}M${size*0.19} ${size/2}l${size*0.31} -${size*0.31} ${size*0.31} ${size*0.31}`}
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function StopIcon({ size = 16, ...rest }: IconProps) {
  const pad = size * 0.28;
  return (
    <svg {...base(size)} {...rest}>
      <rect x={pad} y={pad} width={size - pad * 2} height={size - pad * 2} rx={1.5} fill="currentColor" />
    </svg>
  );
}

export function RetryIcon({ size = 14, ...rest }: IconProps) {
  return (
    <svg {...base(size)} {...rest}>
      <path
        d="M13 8a5 5 0 1 1-1.46-3.54"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M13 3v3h-3"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
